import { createConsts, createActions } from '../../utils/redux';

const supportedActions = ['ADD', 'DELETE'];

export const consts = createConsts('ui', 'formInProgress', ...supportedActions);
export const actions = createActions(consts);

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.ADD:
      return action.payload;
    case consts.DELETE:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/formInProgress.js